import { ProgressSpinner } from 'primereact/progressspinner'
import { useContext } from 'react'
import Login from '../../pages/Login/LoginPage'
import { AuthContext } from './AuthContext'

export const AuthRequire = ({ children }) => {
  const { isLoading, user } = useContext(AuthContext)

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )
  }

  const bypassLogin = true

  if (bypassLogin) {
    return children
  }

  if (user) {
    return children
  }

  return <Login />
}